import { TileInfo } from "@/components/license-details/tile-info";
import {
  PARTY_ROLE_BLURBS,
  type PartyRole,
  partyRoleFromQuestionText,
} from "@/lib/help-parties";

export function PartyRoleInfo({
  questionText,
  party,
}: {
  questionText?: string;
  party?: PartyRole;
}) {
  const resolved =
    party ?? (questionText ? partyRoleFromQuestionText(questionText) : null);
  if (!resolved) return null;
  const copy = PARTY_ROLE_BLURBS[resolved];
  return <TileInfo label={resolved} title={copy.title} body={copy.body} />;
}
